import { Backdrop, Box, Fade, Modal } from "@mui/material";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";

import toast, { Toaster } from "react-hot-toast";
import AddedPhotosCompletedWork from "../../components/AddedPhotosCompletedWork/AddedPhotosCompletedWork";
import AddedPhotosCustomerOrder from "../../components/AddedPhotosCustomerOrder/AddedPhotosCustomerOrder";
import AdditionalInfoOrder from "../../components/AdditionalInfoOrder/AdditionalInfoOrder";
import AddressDetailsOrder from "../../components/AddressDetailsOrder/AddressDetailsOrder";
import CleanerShortDetails from "../../components/CleanerShortDetails/CleanerShortDetails";
import Loader from "../../components/Loader/Loader";
import PackageDetailsOrder from "../../components/PackageDetailsOrder/PackageDetailsOrder";
import TriangleStepper from "../../components/TriangleStepper/TriangleStepper";
import avatar from '../../constants/images/avatar.svg';
import { resolveMediaUrl } from "../../configs/urls";
import coins from '../../constants/images/detailsOrder/coins.svg';
import creditCardCheck from '../../constants/images/detailsOrder/credit-card-check.svg';
import safe from '../../constants/images/detailsOrder/safe.svg';
import support from '../../constants/images/detailsOrder/tech-support.svg';
import { orderActions } from "../../store/slices/orderSlice";
import { qrCodeActions } from "../../store/slices/qrCodeSlice";
import FeedbackPageCustomer from "../FeedbackPageCustomer/FeedbackPageCustomer";
import styles from './ConfirmOrderPage.module.scss';

const ConfirmOrderPage = ({currentStep, setCurrentStep, isOrder}) => {
    const [isModalFeedbackOpen, setIsModalFeedbackOpen] = useState(false);

    const dispatch = useDispatch();
    const {order, status: isLoading} = useSelector(state => state.order);
    const {offer, status: statusOrder, to_cleaner_feedback, to_client_feedback} = order || {};
    const {created_by_user, application_price} = offer?.application || {};
    const {last_name, first_name} = created_by_user || {};

    const {
        request_datetime,
        address,
        room_count,
        reg_window_count,
        wc_count,
        cleaning_type,
        pano_window_count,
        services,
        present_at_home,
        present_at_home_desc,
        comment,
        photos,
        service_package,
    } = offer?.cleaner_request || {};

    useEffect(() => {
        const getOrderById = async () => {
            try {
                await dispatch(orderActions.getById({id: isOrder}));
            } catch (error) {
                console.error(error);
            }
        }

        if (isOrder) {
            getOrderById();
        }

        return () => {
            toast.remove("feedback-customer");
        }
    }, [dispatch, isOrder]);

    if (isLoading === 'loading') {
        return <Loader/>
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 4
    };

    const generateQrCode = async () => {
        try {
            await dispatch(qrCodeActions.generate());
        } catch (error) {
            console.error(error);
        }
    }

    const handleOpenModal = async () => {
        await generateQrCode();
        setIsModalFeedbackOpen(true);
    }

    return (
        <div className={styles.confirmOrderPage_wrapper}>
            <div className={styles.confirmOrderPage}>
                <h1 className={styles.confirmOrderPage_title}>{service_package?.name}</h1>

                <TriangleStepper
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    isOrder={true}
                />

                <div className={styles.confirmOrderPage_orderInfo}>
                    <div className={styles.confirmOrderPage_orderInfo_leftSide}>
                        <div>
                            <AddressDetailsOrder
                                date={new Date(request_datetime).toLocaleDateString()}
                                address={address}
                                price={null}
                                time={new Date(request_datetime).toLocaleTimeString()}
                            />
                            <PackageDetailsOrder
                                style={{'padding': '24px 24px 16px 24px', 'borderBottom': '1px solid #D9DBDD'}}
                                showTitle={true}
                                countRooms={room_count}
                                typeCleaning={cleaning_type}
                                countBathrooms={wc_count}
                                countOrdinaryWindows={reg_window_count}
                                countPanoramicWindows={pano_window_count}
                                services={services}
                                selectedPackage={service_package?.name}
                            />
                            <CleanerShortDetails
                                photo={resolveMediaUrl(created_by_user?.photos?.[0]) || avatar}
                                firstName={first_name}
                                lastName={last_name}
                                phoneNumber={created_by_user?.mobile_nummer}
                            />
                            <AdditionalInfoOrder
                                present_at_home={present_at_home}
                                additionalComments={comment}
                                present_at_home_desc={present_at_home_desc}
                            />
                            {photos?.length > 0 && <AddedPhotosCustomerOrder photos={photos}/>}
                        </div>

                        {(to_cleaner_feedback || to_client_feedback) &&
                            <AddedPhotosCompletedWork
                                clientPhotos={to_cleaner_feedback?.photos || []}
                                cleanerPhotos={to_client_feedback?.photos || []}
                            />}
                    </div>
                    <div className={styles.confirmOrderPage_orderInfo_rightSide}>
                        <div className={styles.confirmOrderPage_orderInfo_rightSide_payment}>
                            <p className={styles.confirmOrderPage_orderInfo_rightSide_payment_title}>Оплата</p>
                            <div className={styles.confirmOrderPage_orderInfo_rightSide_payment_content}>
                                <div
                                    className={styles.confirmOrderPage_orderInfo_rightSide_payment_content_blockContainer}>
                                    <div
                                        className={styles.confirmOrderPage_orderInfo_rightSide_payment_content_blockContainer_subtitle}>
                                        <img src={coins} alt="coins icon"/>
                                        <p>Ціна прибирання</p>
                                    </div>
                                    <p>₴ {+application_price}</p>
                                </div>

                                <div
                                    className={styles.confirmOrderPage_orderInfo_rightSide_payment_content_blockContainer}>
                                    <div
                                        className={styles.confirmOrderPage_orderInfo_rightSide_payment_content_blockContainer_subtitle}>
                                        <img src={safe} alt="safe icon"/>
                                        <p>Застраховані кошти</p>
                                    </div>
                                    <p>₴ {+application_price}</p>
                                </div>

                                <div
                                    className={styles.confirmOrderPage_orderInfo_rightSide_payment_content_blockContainer}>
                                    <div
                                        className={styles.confirmOrderPage_orderInfo_rightSide_payment_content_blockContainer_subtitle}>
                                        <img src={creditCardCheck} alt="credit card check icon"/>
                                        <p>Виплачено Клінеру</p>
                                    </div>
                                    <p>₴ {to_client_feedback ? +application_price : 0}</p>
                                </div>
                            </div>

                            {(statusOrder !=="FINISHED-FAILED" && statusOrder !=="FINISHED-SUCCESS") && <>
                                <p className={styles.confirmOrderPage_orderInfo_rightSide_payment_rule}>Ви зможете
                                    підтвердити
                                    замовлення після його виконанням клінером, або ж воно буде автоматично підтверджене
                                    через 7
                                    днів після його закінчення.
                                </p>

                                <button
                                    onClick={handleOpenModal}
                                    className={`
                                ${styles.confirmOrderPage_orderInfo_rightSide_payment_button} 
                                ${statusOrder === 'APPROVED-BY-CLEANER' ? '' : styles.disabled}
                                `}
                                    disabled={statusOrder !== 'APPROVED-BY-CLEANER'}
                                >Підтвердити
                                </button>
                            </>}
                        </div>

                        <div className={styles.confirmOrderPage_orderInfo_rightSide_support}>
                            <img src={support} alt="tech support logo"/>
                            <div className={styles.confirmOrderPage_orderInfo_rightSide_support_description}>
                                <p className={styles.confirmOrderPage_orderInfo_rightSide_support_description_title}>Виникли
                                    проблеми?</p>
                                <p className={styles.confirmOrderPage_orderInfo_rightSide_support_description_subtitle}>Якщо
                                    у вас виникла проблема чи з’явились запитання щодо роботи нашої компанії,
                                    телефонуйте на
                                    номер </p>
                                <p className={styles.confirmOrderPage_orderInfo_rightSide_support_description_number}>
                                    <a href="tel:+380960000000">+380960000000</a>
                                </p>
                            </div>
                        </div>

                        <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            open={isModalFeedbackOpen}
                            onClose={setIsModalFeedbackOpen}
                            closeAfterTransition
                            slots={{backdrop: Backdrop}}
                            slotProps={{
                                backdrop: {
                                    timeout: 500,
                                },
                            }}
                        >
                            <Fade in={isModalFeedbackOpen}>
                                <Box sx={style}>
                                    <FeedbackPageCustomer
                                        handleClose={() => setIsModalFeedbackOpen(false)}
                                        order={{
                                            id: offer?.order,
                                            name: created_by_user?.first_name,
                                            surname: created_by_user?.last_name,
                                            cleaningType: cleaning_type,
                                        }}
                                    />
                                </Box>
                            </Fade>
                        </Modal>
                    </div>
                </div>
            </div>

            {/*to appear hot toast notification*/}
            <Toaster/>
        </div>
    );
};

export default ConfirmOrderPage;
